let Test = require('@/mixins/Forms/2016/NRCA_LTI_05_A')

module.exports = {

    mixins: [Test],

    methods: {

        // Evaluate test.
        evaluateTest() {
            this.spaces.forEach(space => {
                this.calculateMethodTwoLineC1(space)
                this.calculateMethodTwoLineC2(space)
            })
            this.testResult = (this.functionalTest() && this.constructionInspection()) ? 1 : 0;
            this.form.testResult = !!this.testResult
        },

        // Functional Test
        functionalTest() {
            var result = true;
            this.spaces.forEach(space => {
                if (!space.step_2_line_c2) {
                    result = false;
                }
            });
            return result;
        },

        // Evaluate Line C 1 of Step 2
        calculateMethodTwoLineC1(space) {
            var s1_B1 = this.asNumber(space.step_1_line_b1)
            var s1_B2 = this.asNumber(space.step_1_line_b2)

            var s2_B1 = this.asNumber(space.step_2_line_b1)
            var s2_B2 = this.asNumber(space.step_2_line_b2)

            if (!this.isBlank(s1_B1)) {
                var result = (s2_B1 / s1_B1) * 100
            } else {
                var result = (s2_B2 / s1_B2) * 100
            }

            space.step_2_line_c1 = this.formatResult(result.toFixed(2));
        },

        // Evaluate Line C 2 of Step 2
        calculateMethodTwoLineC2(space) {
            var C1 = this.asNumber(space.step_2_line_c1)
            space.step_2_line_c2 = (C1 <= 85 && !this.isBlank(C1) && C1 != 0) ? 1 : 0;
        },

        // Load data on spaces.
        loadSpaceData(index, data) {
            this.spaces.push({
                step_1_line_a: data.step_1_line_a[index] == "false" ? false : true,
                step_1_line_b1: data.step_1_line_b1[index],
                step_1_line_b2: data.step_1_line_b2[index],
                step_2_line_a: data.step_2_line_a[index] == "false" ? false : true,
                step_2_line_b1: data.step_2_line_b1[index],
                step_2_line_b2: data.step_2_line_b2[index],
                step_2_line_c1: '',
                step_2_line_c2: data.step_2_line_c2[index],
            })
        },

        // Add a new space to the form.
        addSpace() {
            this.spaces.push({
                step_1_line_a: false,
                step_1_line_b1: '',
                step_1_line_b2: '',
                step_2_line_a: false,
                step_2_line_b1: '',
                step_2_line_b2: '',
                step_2_line_c1: 0,
                step_2_line_c2: 0
            })
        },

    }

}
